var map = {
	"./black.png": 61630,
	"./blue.png": 91187,
	"./brown.png": 86163,
	"./darkGreen.png": 62674,
	"./gray.png": 93370,
	"./green.png": 62254,
	"./orange.png": 62089,
	"./pink.png": 67619,
	"./red.png": 87522,
	"./violet.png": 89550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19556;